import React from 'react'
import FinFactorContainer from 'containers/FinFactor/FinFactorContainer'

const FinfactorDashboardPage = () => {
    return (
        <FinFactorContainer />
    )
}

export default FinfactorDashboardPage